import { Button } from "@mui/material";
import Colors from "@src/constants/Colors";
import styled from "styled-components";

export const DividerWrapper = styled.div`
  margin: 0px 4px;
`;

export const NotesWrapper = styled.div``;

export const ChildCardWrapper = styled.div`
  cursor: text;
`;

export const StyledButton = styled(Button)`
  &.MuiButtonBase-root {
    height: 40px;
    padding: 14px 16px;
    gap: 8px;
    border-radius: 8px;
    box-shadow: none;
    background-color: ${Colors.secondary};
    color: #fff;
    line-height: 20px;
    font-family: "Ringside Regular-Book";
    font-size: 14px;
    font-weight: bold;
    text-align: center;
    text-transform: capitalize;

    &:disabled {
      background-color: #ddd;
      color: #fff;
    }

    &:hover {
      background-color: ${Colors.secondary};
      box-shadow: none;
    }
  }
`;

export const EmptyStateContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  flex-direction: column;
  min-height: 180px;

  p {
    font-family: "Ringside Regular-Light";
    margin: 0 0 18px 0;
    font-size: 14px;
    line-height: 20px;
  }
`;

export const EntryContainer = styled.div`
  margin-bottom: 8px;
  margin-top: 8px;
  cursor: text;
`;

export const NewEntryContainer = styled.div`
  margin-bottom: 24px;
  margin-top: 8px;
  cursor: text;
`;
